module.exports = __webpack_public_path__ + "media/notification.d5e6efc3.wav";